import { PAGES } from "@dune/types";
import { GFAFullDetails } from "@dune/types";
import { Button, H2, H3, Separator } from "@dune/ui";
import { FormProvider } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { GFADocumentsTable } from "../../../../component/gfa/GFADocumentsTable";
import GFAFinancingCommercializationPlanContainer from "../../../../component/gfa/GFAFinancingCommercializationPlanContainer";
import GFAFinancingFundRaisingsContainer from "../../../../component/gfa/GFAFinancingFundRaisingsContainer";
import GFAFinancingPlanContainer from "../../../../component/gfa/GFAFinancingPlanContainer";
import GFAFinancingsDetailsContainer from "../../../../component/gfa/GFAFinancingsDetailsContainer";
import GFAFinancingsSummaryContainer from "../../../../component/gfa/GFAFinancingsSummaryContainer";
import { useGFAFinancingsForm } from "../../../../component/gfa/useGFAFinancingsForm";

interface GFAFinancingTabProps {
	gfa: GFAFullDetails;
}

export const GFAFinancingTab = ({ gfa }: GFAFinancingTabProps) => {
	const navigate = useNavigate();
	// const [isModifyModalOpen, setIsModifyModalOpen] = useState(false);

	const { form: financingsForm } = useGFAFinancingsForm(gfa ?? null);

	if (!gfa) return <div>Aucune projet GFA trouvé</div>;

	return (
		<div>
			<div className="flex justify-between items-center">
				<H2>Financement de l'opération</H2>
				<Button
					type="button"
					onClick={() =>
						navigate(PAGES.GFA.edit.withParams(gfa.id.toString(), 3))
					}
				>
					Modifier l'opération
				</Button>
			</div>
			<FormProvider {...financingsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex flex-col flex-1 gap-6">
						<GFAFinancingsDetailsContainer isForm={false} />
						<GFAFinancingsSummaryContainer />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="FINANCING_DETAILS_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />
			<FormProvider {...financingsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">PLAN DE FINANCEMENT</H3>
						</div>
						<GFAFinancingPlanContainer isForm={false} />
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />
			<FormProvider {...financingsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">PLAN DE COMMERCIALISATION</H3>
						</div>
						<GFAFinancingCommercializationPlanContainer isForm={false} />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="FINANCING_COMMERCIALIZATION_PLAN_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>

			<Separator className="my-8" />
			<FormProvider {...financingsForm}>
				<div className="flex flex-row gap-4">
					<div className="flex-1">
						<div className="flex flex-row justify-between items-center">
							<H3 className="mb-0">GRILLE D'APPEL DE FONDS</H3>
						</div>
						<GFAFinancingFundRaisingsContainer isForm={false} />
					</div>
					<div className="flex-1">
						<GFADocumentsTable
							gfaConstructionSite={gfa}
							section="FINANCING_FUND_RAISING_FILES"
							isForm={false}
						/>
					</div>
				</div>
			</FormProvider>
		</div>
	);
};
